import { render, staticRenderFns } from "./topicBank.vue?vue&type=template&id=246dda23&"
import script from "./topicBank.vue?vue&type=script&lang=js&"
export * from "./topicBank.vue?vue&type=script&lang=js&"
import style0 from "./topicBank.vue?vue&type=style&index=0&id=246dda23&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports